import { HTMLAttributes, memo } from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
  width: 100%;
  overflow: hidden;
`;

const List = styled.div<{ translateX: string; width: string; offset: string }>`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  transform: ${({ translateX }) => `translateX(${translateX})`};
  transition: transform 0.2s;
  > * {
    flex: ${({ width }) => `0 0 ${width}`};
    margin-right: ${({ offset }) => offset};
  }
`;

export interface SlideProps extends HTMLAttributes<HTMLDivElement> {
  count: number;
  index: number;
  offsetPercent: number;
}

function Slide(props: SlideProps) {
  const { count, index, offsetPercent, children, ...otherProps } = props;

  const widthPercent = (100 - (count - 1) * offsetPercent) / count;

  const slidePercent = widthPercent + offsetPercent;

  return (
    <Container {...otherProps}>
      <List
        translateX={`-${slidePercent * index}%`}
        width={`${widthPercent}%`}
        offset={`${offsetPercent}%`}
      >
        {children}
      </List>
    </Container>
  );
}

export default memo(Slide);
